import "./style.css";
import { useState,useEffect } from "react";
import React from "react";
import { ThemeProvider, createTheme } from "@mui/material";
import { useInView } from "framer-motion";
import { useRef } from "react";
import anime from 'animejs';
import ScrollToTop from '../../Components/scrollup'
import ScrollPage from "../../Components/scrollpageUp";
import { Realisation } from "../../Data/cardData";
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import IconButton from '@mui/material/IconButton';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import Skeleton from '@mui/material/Skeleton';
const customTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1080,
      lg: 1280,
    },
  },
  palette: {
    primary: {
      main: "#00897b",
      light: "#80cbc4",
      dark: "#00695c",
      contrastText: "#fff",
    },
  },
});
export default function RealisationsFamilles() {
  const [path1, setPath1] = React.useState('');
    const [path2, setPath2] = React.useState('');
    React.useEffect(() => {
        let pathName = window.location.pathname;
        let pathe = pathName.replace(/%20/g, ' ');
        let newPath1 = pathe.split('/')[2];
        let newPath2 = pathe.split('/')[3];
        setPath1(newPath1);
        setPath2(newPath2);
      }, []);



 
  const ref2 = useRef(null);
  const isInView2 = useInView(ref2, { once: true });
  const ref3 = useRef(null);
  const isInView3 = useInView(ref3, { once: true });
  useEffect(() => {
    const timer = setTimeout(() => {
      const elements = document.querySelectorAll(".realisationDiv:not(.vide)");
      anime({
        targets: elements.length > 0 ? elements : ".realisationDiv",
        translateX: [400, 0],
        opacity: [0, 1],
        scale: [0, 1],
        delay: anime.stagger(200, { start: 300 }),
        easing: "easeInOutQuad",
      });
    }, 0); // attendre que React mette à jour le DOM
    
    return () => clearTimeout(timer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path1, path2, Realisation]);
  const selected = Realisation.find(x => x.name === path1);

        const [showImage, setShowImage] = useState(false);
     useEffect(() => {
        const timer = setTimeout(() => {
          setShowImage(true);
        }, 1500); // 1 seconde
    
        return () => clearTimeout(timer);
      }, []);
  return (
    <ThemeProvider theme={customTheme}>
      <div className="home">
        <ScrollToTop/>
        <ScrollPage/>
        {path1  && (
           !showImage ? (
        <Skeleton  sx={{ bgcolor: 'grey.900' }} variant="rectangular" width="100vw" height="50vh" />
      ) : (
  <div
    className="sousprojetsBack"
    style={{
      backgroundImage: `url(https://firebasestorage.googleapis.com/v0/b/saveurs-fatma.appspot.com/o/ellouzeAlu%2Frealisations%2Fcouverture%2F${(path1)}.jpg?alt=media)`,
    }}
  >
  
  </div>)
)}
<div className="projetsTitle"   ref={ref3}
                  style={{
                    transform: isInView3 ? "none" : "translateX(-200px)",
                    opacity: isInView3 ? 1 : 0,
                    transition:
                      "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.6s",
                  }}> <h2 >Découvrez nos projets {decodeURIComponent(path1)} sur-mesure</h2>
</div>
 
         <Box sx={{ width: '90vw',marginTop:'50px'  }} >
      <ImageList variant="masonry" cols={3} gap={8}   ref={ref2}
                  style={{
                    transform: isInView2 ? "none" : "translateX(-200px)",
                    opacity: isInView2 ? 1 : 0,
                    transition:
                      "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.6s",
                  }}>
       {selected?.projets?.map((item, idx) => (
          <ImageListItem key={item.nom} className="realisationDiv" >
          
            <img
              srcSet={`${`https://firebasestorage.googleapis.com/v0/b/saveurs-fatma.appspot.com/o/ellouzeAlu%2Frealisations%2F${encodeURIComponent(path1)}%2F${encodeURIComponent(item.nom)}.jpg?alt=media`}`}
              src={`${`https://firebasestorage.googleapis.com/v0/b/saveurs-fatma.appspot.com/o/ellouzeAlu%2Frealisations%2F${encodeURIComponent(path1)}%2F${encodeURIComponent(item.nom)}.jpg?alt=media`}`}
              alt={item.title}
              loading="lazy"
            />
            <a href={`/${item.nom}`} className="sousRefLink">
          <ImageListItemBar
          sx={{backgroundColor:'#1976D2'}}
  position="below"
  title={item.nom}
  className="sousRefText"
  actionIcon={
    <IconButton
      sx={{ color: 'white' }}
      aria-label={`info about ${item.nom}`}
      className="iconBtn"
    >
      <ArrowCircleRightOutlinedIcon />
    </IconButton>
  }
/>
            </a>
          </ImageListItem>
        ))}
      </ImageList>
    </Box>
    </div>
      
    </ThemeProvider>
  );
}

